export const negocios = [
    {
        "id": "fincabuenavista",
        "description": "Descubre la verdadera esencia de Turrialba en nuestras cabañas, donde la naturaleza es tu vecina más cercana. Con vistas impresionantes y la serenidad del lugar, podrás disfrutar una experiencia de hospedaje única. Desde acogedoras cabañas para 2 personas hasta nuestra cabaña para 20 personas con piscina privada, tenemos opciones para todos los gustos y necesidades.",
        "name": "Finca Buena Vista",
        "address": "San Antonio, Santa Cruz, 500 metros norte de Haras Turrialba, entrada barrio Los Angeles",
        "linkAddress": "https://maps.app.goo.gl/9x4dkzeaptVYVm1A6",
        "contact": "Teléfono: 62-38-53-73. Facebook: Finca Buena Vista. Instagram: finca_buena_vista. Tik Tok: @fincabuenavistaturrialba",
        "info": "Con reserva. Se aceptan mascotas, cuenta con senderos, totalmente equipadas, e internet",
        "administration": "Familia López Porras",
        "images": [
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313526/db8a52f7-8e87-4994-9d79-309ead85b60b_aaoizj.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730319777/458378045_992989135958939_788128343085432908_n_swuoz6.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313525/WhatsApp_Image_2024-10-21_at_12.18.14_PM_1_zmdwfv.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313524/WhatsApp_Image_2024-10-21_at_12.18.13_PM_1_bnqjhw.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313523/WhatsApp_Image_2024-10-21_at_12.18.14_PM_i6y8ro.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313522/WhatsApp_Image_2024-10-21_at_12.18.13_PM_jcsfdb.jpg"
        ]
    },
    {
        "id": "colinalossuenos",
        "description": "Cabañas completamente equipadas en un espacio para relajarsre. Con el propósito de que en medio del silencio los clientes logren conectarse con la naturaleza.",
        "name": "Colinas Los Sueños ",
        "address": " San Antonio de Santa Cruz, 1, 2 km al Este del Salón Comunal",
        "linkAddress": "https://waze.com/ul/hd1u2xm36n",
        "contact": "Teléfonos:88-77-00-11, 87-85-14-39. Facebook:Colina los Sueños ",
        "info": "No se permiten Fiestas. Pet Friendly.",
        "administration": "Familia Calvo Hernández",
        "images": [
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730757079/WhatsApp_Image_2024-11-02_at_7.33.14_AM_10_drmhdh.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730757084/WhatsApp_Image_2024-11-02_at_7.33.14_AM_4_eb7yio.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730757084/WhatsApp_Image_2024-11-02_at_7.33.14_AM_6_lakevn.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730757084/WhatsApp_Image_2024-11-02_at_7.33.14_AM_5_emsfjf.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730757081/WhatsApp_Image_2024-11-02_at_7.33.14_AM_3_uwkdxi.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730757079/WhatsApp_Image_2024-11-02_at_7.33.14_AM_7_x30rby.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730757079/WhatsApp_Image_2024-11-02_at_7.33.14_AM_8_pyfnwm.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730757079/WhatsApp_Image_2024-11-02_at_7.33.14_AM_10_drmhdh.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730757079/WhatsApp_Image_2024-11-02_at_7.33.14_AM_dhxbdk.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730757079/WhatsApp_Image_2024-11-02_at_7.33.14_AM_1_b9iuuv.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730757079/WhatsApp_Image_2024-11-02_at_7.33.14_AM_9_r3ymdg.jpg"
        ]
    },
    {
        "id": "kyluvas",
        "description": "El proyecto KLYUVAS Garden tiene un enfoque turístico a través de una cabaña amplia, con hospedaje para 4 personas.",
        "name": " KYLUVAS",
        "address": "San Antonio, Santa Cruz, Barrio Los Liris, antes del puente de los melos.",
        "contact": "Teléfonos: 86-11-18-30 Valeria (Comunicación en Inglés y español). Instagram: Cabana_Luciernaga",
        "info": "Hora de ingreso: 2pm. Hora de salida: 11am. Se admiten mascotas. No se permiten fiestas ni música fuerte después de las 9pm",
        "administration": "Krisia Arguedas Núñez & Valeria Jiménez Arguedas",
        "images": [
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313685/WhatsApp_Image_2024-10-21_at_2.42.04_PM_d2czfg.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313684/WhatsApp_Image_2024-10-21_at_2.42.05_PM_zni4wm.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313682/WhatsApp_Image_2024-10-21_at_2.42.03_PM_1_g4lnww.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313680/WhatsApp_Image_2024-10-21_at_2.42.06_PM_ne8wjj.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313680/WhatsApp_Image_2024-10-21_at_2.42.04_PM_1_eqnths.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313678/WhatsApp_Image_2024-10-21_at_2.42.03_PM_msvbgy.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313677/WhatsApp_Image_2024-10-21_at_2.42.05_PM_2_kx5amu.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313675/WhatsApp_Image_2024-10-21_at_2.42.05_PM_1_sxwlub.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313674/WhatsApp_Image_2024-10-21_at_2.42.02_PM_vnkdnf.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313673/WhatsApp_Image_2024-10-21_at_2.42.01_PM_su6bzc.jpg"
        ]
    },
    {
        "id": "dgirasoles",
        "description": "Artesanías, trabajos en madera, resina, cemento blanco, porcelana fría, aretes, llaveros, detallitos personalizados para regalar.",
        "name": "D'Girasoles",
        "address": "San Antonio, Santa Cruz, frente a la plaza de fútbol, casa color verde",
        "contact": "Teléfono: 85-14-69-05. Facebook: D'Girasoles",
        "administration": "Edwin Castillo & Seidy Castillo",
        "images": [
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224483/IMG_0246_ztogso.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224471/IMG_0261_rmzgrl.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224467/IMG_0270_n4pw3y.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224432/IMG_0274_ffvcsi.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224429/IMG_0278_cqbd1f.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224420/IMG_0279_fafug5.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730222441/IMG_0282_f3citk.jpg"
        ]
    },
    {
        "id": "bambuessanantonio",
        "description": "Muebles en Bambú, de cocina, sala, baños, cuarto, camas, cortinas, libreros, maceteros.",
        "name": "Bambues San Antonio.",
        "address": "San Antonio, Santa Cruz, frente a la plaza de futbol. Bambues expuestos",
        "contact": "Teléfono: 84-90-33-77",
        "administration": "José Manuel Brenes",
        "images": [
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313047/IMG_0211_1_wgolaa.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313041/IMG_0227_ym8xho.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224505/IMG_0212_kt7es6.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224498/IMG_0222_x4ix27.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224491/IMG_0225_tfswuc.jpg",
        ]
    },
    {
        "id": "cabanasanantonio",
        "description": "Un hospedaje rodeado de naturaleza. Un paisaje, lleno de paz, tranquilidad, rodeado de verde, campo y montaña",
        "name": "Cabaña San Antonio",
        "address": "San Antonio, Santa Cruz. Cabaña y camping San Antonio, 100m al este de la iglesia.",
        "linkAddress": "https://maps.app.goo.gl/bMMrvW6ahjomwWTV7",
        "contact": "Teléfono: 60-87-26-35. Facebook: Cabaña San Antonio",
        "administration": "Leonardo Pereira Zúñiga ",
        "images": [
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313393/48420278_557111944701315_2687968165094227968_n_bknwqr.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313391/358091535_749906946932398_8951378525224935012_n_cgygov.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313390/357731245_749906473599112_4097847608967899687_n_zdnqep.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313389/WhatsApp_Image_2024-10-25_at_6.25.48_AM_plctxb.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313389/WhatsApp_Image_2024-10-25_at_6.25.48_AM_plctxb.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313388/48397684_557113684701141_5253676925011886080_n_kzrlic.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313388/WhatsApp_Image_2024-10-25_at_6.25.49_AM_dqb7af.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313387/WhatsApp_Image_2024-10-25_at_6.25.48_AM_1_ec21oy.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313386/WhatsApp_Image_2024-10-25_at_6.25.47_AM_nk9b9g.jpg"
        ]
    },
    {
        "id": "fincavillamatilde",
        "description": "Finca familiar, con dos cabañas equipadas. Senderos, catarata, río, orquideas y mucha naturaleza.",
        "name": "Finca Villa Matilde",
        "address": "San Antonio, Santa Cruz. de la escuela 1.5 km. Al norte",
        "linkAddress": "https://maps.app.goo.gl/M8LXsjpq7ky6GchXA",
        "contact": "Teléfonos: (Sinpe Movil 86-84-02-20), 87-80-69-69,  86-62-88-13. Correo: fincavillamatilde76@gmail.com. Facebook: Finca Villa Matilde",
        "administration": "Luz Marina Hidalgo Umaña & Gerardo Alvarez Jimenez",
        "images": [
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730400030/1_xrhqv7.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730400030/5_ibovvj.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730400029/2_y7x9is.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730400028/3_jcyilq.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730400028/4_f4odhz.jpg"
        ]
    },
    {
        "id": "posadavistasdecanon",
        "description": "La dinámica del lugar está orientada a la atención de grupos de personas que gusten de la naturaleza y de realizar diferentes actividades en un ambiente familiar, rural, ecológico, y relajante.",
        "name": "Posada de Montaña Vistas de Cañón",
        "address": "San Diego, San Antonio de Santa Cruz, Turrialba",
        "linkAddress": "https://maps.app.goo.gl/94rtLGLwFHc3EWRn8",
        "contact": "Teléfono: 84-79-01-75",
        "administration": "Mario A. Brenes Coto",
        "images": [
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730320158/2_vyaofs.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730320212/2_hgmk1y.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313736/6_q2m3fa.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313735/5_uumcuj.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313734/4_q2dp6l.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313734/3_g6h73e.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313732/2_apo7zh.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313729/1_ms52tg.jpg"
        ]
    },
    {
        "id": "casaoropel",
        "description": "Hospedaje de paso, ubicado en San Antonio, para aquellas personas que les gusta la montaña y desconectarse de la ciudad.",
        "name": "Casa Oropel",
        "address": "San Antonio, Santa Cruz ",
        "linkAddress": "https://maps.app.goo.gl/VjyToC8iqN9UDdQs6",
        "contact": "Teléfono: 86-17-70-40. Facebook: Casa Oropel",
        "administration": "Selena Gamboa",
        "images": [
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730399950/4_dys18n.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730399950/3_hyuqhu.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730399950/5_owv58s.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730399950/1_k15pdm.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730399950/2_q8maqi.jpg"
        ]
    },
    {
        "id": "harasturrialba",
        "description": "Centro turístico, restaurante, sala de eventos para hasta 700 personas.",
        "name": "Haras Turrialba",
        "address": "San, Antonio, Santa Cruz, Turrialba",
        "linkAddress": "https://maps.app.goo.gl/D9BkR9iT3g2yqYTU6",
        "contact": "Teléfono: 84-34-27-27. Facebook: Haras Turrialba. Instagram: harasturrialba. Tik Tok: haras_turrialba",
        "administration": "Greivin Brenes Ulloa",
        "images": [
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313607/322160705_928389081654041_7600578470838757658_n_vpa8zd.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313606/WhatsApp_Image_2024-10-25_at_10.05.13_AM_navotv.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313605/WhatsApp_Image_2024-10-25_at_10.04.58_AM_ntluar.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313603/316819127_796902468431231_7712403045604879575_n_e8jyuo.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313602/WhatsApp_Image_2024-10-25_at_10.04.57_AM_slo9it.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313601/322615055_1184559242157037_1899439290486080073_n_wb08m8.jpg"
        ]
    },
    {
        "id": "angiemontoya",
        "description": "Guía de Turismo Rural, Certificada por el ICT, Español/Inglés Especializada en senderismo e interpretación natural y cultural del país. ''Una de las cosas que más disfruto de mi trabajo es transmitir la esencia de la gente, la experiencia rural, que más que un tour se convierta en una actividad vivencial donde las personas puedan aprender pero también interactuar con quienes presentan el servicio o actividad que se vaya a desarrollar.''",
        "name": "Angie Montoya",
        "address": "San, Antonio",
        "linkAddress": "https://www.yhamoretours.com",
        "contact": "Teléfono: 7174-8149",
        "administration": "Angie Montoya",
        "images": [
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730916746/WhatsApp_Image_2024-10-31_at_11.01.49_AM_1_vzzzcr.jpg"
        ]
    },
    {
        "id": "sanantonioparadise",
        "description": "Una casa para familias o personas que necesiten hospedaje en el centro de San Antonio, con patios amplios",
        "name": "San Antonio Paradise",
        "address": "San, Antonio, 100 sur y 50 este de la plaza",
        "linkAddress": "https://maps.app.goo.gl/CDGDxcSJPrnLC5KK7",
        "contact": "Teléfono: 8840-5502",
        "administration": "Gustavo Romero & Daniela Garro",
        "images": [
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730917075/2_jereid.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730917075/3_y33q0x.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730917075/4_m6tfzu.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730917075/1_yhtjem.jpg"
        ]
    },
    {
        "id": "lastrillizas",
        "description": "Empresa familiar que brinda tours a las cataratas trillizas",
        "name": "Cataratas Las Trillizas",
        "address": "San Antonio, Santa Cruz, dos kilometros y medio al oeste de la iglesia de San Antonio ",
        "linkAddress": "https://maps.app.goo.gl/r3ra6mSgFbNFGkvPA",
        "contact": "Teléfono: 85-00-37-54, 87-98-30-46. Facebook: Cataratas las Trillizas. Instagram: C.Trillizas_Oficial",
        "administration": "Milagro Astua Vargas & Alfonso Guillen Vargas",
        "images": [
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313466/WhatsApp_Image_2024-10-23_at_4.51.31_PM_dt5or2.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313465/WhatsApp_Image_2024-10-23_at_4.51.59_PM_hmobsr.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313464/457376935_1056763273125823_7182117368141395411_n_u8ewfj.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313463/415846096_883280883807397_534411030716355645_n_iju80l.jpg",
            "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730313462/331296094_876761586947813_4498227211412922920_n_fsz86j.jpg"
        ]
    },
];


export const sanAntonioImages = [
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224617/IMG_0139_ugqfzp.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224618/IMG_0148_sj2cfx.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224615/IMG_0126_n4vfzb.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224632/IMG_0113_vrg88q.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224636/IMG_0095_s3kiwy.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224640/IMG_0124_mfdhaw.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224638/IMG_0093_qcff9q.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224644/IMG_0117_a4ixzu.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224667/IMG_0076_tzwlcm.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224642/IMG_0120_ekj5ug.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224610/IMG_0138_ubgfgz.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224609/IMG_0127_nam3iq.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224594/IMG_0159_zlqzvd.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224594/IMG_0172_igvwhh.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1730224595/IMG_0191_qixjvg.jpg"
];


export const caminoDelPoetaImages = [
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1732301836/5fb1ecbe-2e38-4b12-b543-791d07e30e6b_xqvqcr.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1732301829/56467a38-b8c5-4135-890a-d0f7a1887294_amou9r.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1732301818/f233ae97-54d1-4365-b88c-9051ee7c16cf_v1zhxs.jpg"
];

export const caminoDelPoetaStoriesImages = [
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1732714549/Iglesia_del_padre_nuestro_b0khrd.jpg",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1732714550/Ctarata_verde_tpcdtl.png",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1732714554/Ladera_de_los_duendes_qfzfsm.png",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1732714553/El_espejo_de_Hernan_Carazo_a3son3.png",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1732714556/El_cruce_del_caballo_blanco_ujq6pb.png",
    "https://res.cloudinary.com/dri6lpx9p/image/upload/v1732714581/Arbol_Blanco_l6dxvx.png"
];
